import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { find, forEach, get, hasIn, map, set } from 'lodash';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';

import * as atlasOps from '../../../api/Atlas/atlas-operations';
import Atlas from '../../../api/Atlas/Atlas';

import getAtlasPropsToPass from '../../../modules/get-atlas-props-to-pass';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import { ATLAS_ELEMENTS } from '../../atoms/AtlasAtoms/atlas-elements';
import PageHeader from '../../atoms/PageHeader';
import ShareColumn from '../../atoms/ShareColumn';
import Loading from '../../components/Loading';
import NotFound from '../NotFound';

const { isTierra2 } = Meteor.settings.public;

const NAV_BAR_HEIGHT = 56;
const HEADER_HEIGHT = 54; // When it is all in the same line
const LEFT_VERTICAL_HEIGHT = NAV_BAR_HEIGHT + HEADER_HEIGHT;

class ViewAtlas extends Component {
  handleRemove = async (atlasId, history) => {
    try {
      await methodPromise('atlas.softDelete', atlasId);
      Bert.alert('Atlas deleted!', 'warning');
      history.push(`/atlas`);
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleShared = async (atlasId, isSharedAtlas) => {
    try {
      await methodPromise('atlas.toggleShared', atlasId, !isSharedAtlas);
      if (!isSharedAtlas) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleSharedPrivate = async (atlasId, isSharedAtlas) => {
    try {
      await methodPromise('atlas.toggleSharedPrivate', atlasId, !isSharedAtlas);
      if (!isSharedAtlas) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  toggleSharedUser = async (atlasId, isSharedAtlas) => {
    try {
      await methodPromise('atlas.toggleSharedUser', atlasId, !isSharedAtlas);
      if (!isSharedAtlas) {
        Bert.alert('Link Created', 'success');
      } else {
        Bert.alert('No longer Shared', 'info');
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  render() {
    const { atlas, deployEnv, history, loading, match } = this.props;

    if (loading) return <Loading />;
    if (atlasOps.isDeleted(atlas) || isTierra2) return <NotFound />;

    const atlasProps = getAtlasPropsToPass(atlas);
    const heightToRemove = get(
      find(atlasProps, element => hasIn(element, 'navbarHeight')),
      'navbarHeight'
    );
    forEach(atlasProps, element => {
      if (!hasIn(element, 'navbarHeight')) set(element, 'heightToRemove', heightToRemove);
    });

    return (
      <>
        <PageHeader>
          <h4 className="mr-auto">{atlasOps.getName(atlas)}</h4>
          <ButtonGroup size="sm">
            <Button variant="outline-info" onClick={() => history.push(`${match.url}/edit`)}>
              Edit
            </Button>
            <Button
              onClick={() => this.handleRemove(atlasOps.getId(atlas), history)}
              variant="outline-danger"
            >
              Delete
            </Button>
          </ButtonGroup>
        </PageHeader>
        <Row noGutters>
          <ShareColumn
            isShared={atlasOps.isShared(atlas)}
            isSharedPrivate={atlasOps.isSharedPrivate(atlas)}
            isSharedUser={atlasOps.isSharedUser(atlas)}
            sharedPath={`shared/atlas/${atlasOps.getPublicId(atlas)}`}
            sharedPathPrivate={`sharedPrivate/atlas/${atlasOps.getPublicId(atlas)}`}
            sharedPathUser={`sharedUser/atlas/${atlasOps.getPublicId(atlas)}`}
            toggleShared={() => this.toggleShared(atlasOps.getId(atlas), atlasOps.isShared(atlas))}
            toggleSharedPrivate={() =>
              this.toggleSharedPrivate(atlasOps.getId(atlas), atlasOps.isSharedPrivate(atlas))
            }
            toggleSharedUser={() =>
              this.toggleSharedUser(atlasOps.getId(atlas), atlasOps.isSharedUser(atlas))
            }
          />

          <Col xs={12} sm={8} md={9}>
            <div style={{ height: `calc(100vh - ${LEFT_VERTICAL_HEIGHT}px)` }}>
              {map(atlasOps.getAtlasStructure(atlas), (element, index) => {
                const { component } = find(ATLAS_ELEMENTS.properties, ['value', element]);
                return React.cloneElement(component, {
                  atlas,
                  deployEnv,
                  key: `${element}-${index}-view`,
                  showButtons: atlasOps.areButtonsShown(atlas),
                  ...atlasProps[index]
                });
              })}
            </div>
          </Col>
        </Row>
      </>
    );
  }
}

ViewAtlas.defaultProps = {
  atlas: {}
};

ViewAtlas.propTypes = {
  atlas: PropTypes.object,
  deployEnv: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired
};

export default withTracker(({ match }) => {
  const atlasId = match.params.atlas_id;
  const atlasSub = Meteor.subscribe('atlas.view', atlasId);

  return {
    loading: !atlasSub.ready(),
    atlas: Atlas.findOne(atlasId)
  };
})(ViewAtlas);
